import React, { createContext, useContext, useState, useEffect } from 'react';
import dialogEventEmitter from '../utils/dialogEventEmitter';
import useConfig from '../hooks/useConfig';
import RemoveCookies from '../RemoveCookies';
import { redirectToAuthPortalLogout, getAuthPortalLoginUrl } from '../utils/authPortal';
const DialogContext = createContext();

export function useDialog() {
  return useContext(DialogContext);
}

export const DialogProvider = ({ children }) => {
  const { showLoader, hideLoader } = useConfig();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: '',
    content: '',
    calledFrom: 'useApi'
  });

  useEffect(() => {
    const handleShowDialog = (data) => {
      setDialogData({
        title: data.title,
        content: data.content,
        calledFrom: data.calledFrom
      });
      setDialogOpen(true);
    };

    dialogEventEmitter.on('showDialog', handleShowDialog);

    return () => {
      dialogEventEmitter.off('showDialog', handleShowDialog);
    };
  }, []);

  const showDialog = (title, content, calledFrom) => {
    setDialogData({
      title,
      content,
      calledFrom
    });
    setDialogOpen(true);
  };

  const hideDialog = () => {
    if (dialogData.calledFrom == 'useApi') {
      showLoader();
      try {
        // handle the logout here
        RemoveCookies.removeAccCookies().then((logout) => {
          if (logout) {
            redirectToAuthPortalLogout();
          }
        });
      } catch (err) {
        hideLoader();
        if (process.env.authUrl) {
          window.location.href = getAuthPortalLoginUrl();
        }
        console.error(err);
      }
    } else {
      setDialogOpen(false);
      setDialogData({
        title: '',
        content: '',
        calledFrom: 'useApi'
      });
    }
  };

  return (
    <DialogContext.Provider
      value={{
        dialogOpen,
        showDialog,
        hideDialog,
        dialogData
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};
